import React, { useState, useEffect } from "react";
import "../Styles/Navber.css";
import logo from "../Images/Jayraj_logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faUser,
  faCaretDown,
  faAward,
  faHome,
  faHotel,
  faBus,
  faUmbrellaBeach,
  faMapMarkedAlt,
  faSignInAlt,
  faSignOutAlt,
  faUsers,
  faSuitcaseRolling,
  faClock,
  faImages,
  faPlane,
  faHeart,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { GiLovers } from "react-icons/gi";

const TOUR_MENU = [
  { to: "/plantour", icon: faMapMarkedAlt, label: "Plan Tour" },
  { to: "/", icon: faUsers, label: "Group Tour" },
  { to: "/packagetour", icon: faSuitcaseRolling, label: "Package Tour" },
  { to: "/weekendtour", icon: faClock, label: "Weekend Tour" },
];

function Navber() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setToken(localStorage.getItem("accessToken"));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    setToken(null);
    navigate("/signup");
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="jr-navbar">
      {/* LOGO */}
      <div className="jr-logo" onClick={() => navigate("/")}>
        <img src={logo} alt="Jayraj Group" />
      </div>

      {/* ================= MOBILE MENU ================= */}
      {menuOpen && (
        <ul className={`jr-nav-mobile ${menuOpen ? "open" : ""}`}>
          <FontAwesomeIcon
            icon={faXmark}
            className="jr-close-icon"
            onClick={closeMenu}
          />

          <li><NavLink to="/" onClick={closeMenu}><FontAwesomeIcon icon={faHome} /> Home</NavLink></li>

          {TOUR_MENU.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} onClick={closeMenu}>
                <FontAwesomeIcon icon={item.icon} /> {item.label}
              </NavLink>
            </li>
          ))}

          <li><NavLink to="/hotels" onClick={closeMenu}><FontAwesomeIcon icon={faHotel} /> Hotel</NavLink></li>
          {/* <li><NavLink to="/transports" onClick={closeMenu}><FontAwesomeIcon icon={faBus} /> Transport</NavLink></li> */}
          <li><NavLink to="/jayraj-transports/plane" onClick={closeMenu}><FontAwesomeIcon icon={faPlane} /> flight</NavLink></li>
                  <li><NavLink to="/jayraj-transports/bus" onClick={closeMenu}><FontAwesomeIcon icon={faBus} /> Bus</NavLink></li>

          <li><NavLink to="/activities" onClick={closeMenu}><FontAwesomeIcon icon={faUmbrellaBeach} /> Activity</NavLink></li>
          {/* <li><NavLink to="/tour/customtour" onClick={closeMenu}><FontAwesomeIcon icon={faPen} /> Itinerary</NavLink></li> */}
          {/* <li><NavLink to="/awards" onClick={closeMenu}><FontAwesomeIcon icon={faAward} /> Awards</NavLink></li> */}
          {/* <li><NavLink to="/gallery" onClick={closeMenu}><FontAwesomeIcon icon={faImages} /> Gallery</NavLink></li>
          <li><NavLink to="/franchise" onClick={closeMenu}><FontAwesomeIcon icon={faSuitcaseRolling} /> Franchise</NavLink></li> */}
        </ul>
      )}

      {/* ================= DESKTOP MENU ================= */}
      <ul className="jr-nav-links" style={{marginBottom:"0px"}}>
        {/* <li><NavLink to="/"><FontAwesomeIcon icon={faHome} /> Home</NavLink></li> */}

        {/* <li className="jr-dropdown">
          <span>
            <FontAwesomeIcon icon={faUsers} /> Tours <FontAwesomeIcon icon={faCaretDown} />
          </span>
          <div className="jr-dropdown-menu">
            {TOUR_MENU.map((item) => (
              <NavLink key={item.to} to={item.to}>
                <FontAwesomeIcon icon={item.icon} /> {item.label}
              </NavLink>
            ))}
          </div>
        </li> */}
{TOUR_MENU.map((item) => (
   <li key={item.to}><NavLink to={item.to}><FontAwesomeIcon icon={item.icon} /> {item.label}</NavLink></li>
))}

        <li><NavLink to="/hotels"><FontAwesomeIcon icon={faHotel} /> Hotel</NavLink></li>
        {/* <li><NavLink to="/transports"><FontAwesomeIcon icon={faBus} /> Transport</NavLink></li> */}
        <li><NavLink to="/destination-wedding"><GiLovers /> Destination-Wedding</NavLink></li>
        <li><NavLink to="/honeymoon"><FontAwesomeIcon icon={faHeart} /> Honeymoon</NavLink></li>
        <li><NavLink to="/activities"><FontAwesomeIcon icon={faUmbrellaBeach} /> Activity</NavLink></li>
        {/* <li><NavLink to="/tour/customtour"><FontAwesomeIcon icon={faPen} />Itinerary</NavLink></li> */}

        {/* <li>
          <NavLink to="/awards" className="jr-award-btn">
            <FontAwesomeIcon icon={faAward} /> Awards
          </NavLink>
        </li> */}
         {/* <li><NavLink to="/gallery" onClick={closeMenu}><FontAwesomeIcon icon={faImages} /> Gallery</NavLink></li>

        <li>
          <NavLink to="/franchise" className="jr-franchise-btn">
            + Franchise
          </NavLink>
        </li> */}
      </ul>

      {/* ================= RIGHT ACTIONS ================= */}
      {/* <div className="jr-actions">
        {!token ? (
          <button onClick={() => navigate("/signup")} className="jr-login-btn">
            <FontAwesomeIcon icon={faUser} /> Login
          </button>
        ) : (
<div className="jr-profile">
  <div className="jr-profile-icon">
    <FontAwesomeIcon icon={faUser} />
  </div>

  <div className="jr-profile-menu">
    <span onClick={() => navigate("/profile")}>
      <FontAwesomeIcon icon={faUser} /> Profile
    </span>
    <span onClick={handleLogout}>
      <FontAwesomeIcon icon={faSignOutAlt} /> Logout
    </span>
  </div>
</div>

        )}

        <FontAwesomeIcon
          icon={faBars}
          className="jr-menu-icon"
          onClick={() => setMenuOpen(true)}
        />
      </div> */}
    </nav>
  );
}

export default Navber;
